import React, { useEffect, useState } from 'react'
import { getAllAcivity } from '../../../api/casp/activity'
import UserProfile from '../common/userProfile'
import { Action, DefaultPerPageValue } from '../../../constants/Common'
import { ActivityModule, Modules } from '../../../constants/Module'
import Project from './Project'
import Deliverable from './Deliverable'
import Milestone from './Milestone'
import Task from './Task'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../Common/Loader'
import Risk from './Risk'
import ProjectUser from './ProjectUser'
import Document from './Document'
import ApprovalUserProject from './ApprovalUser'
import ApprovalUserUpdateProject from './ApprovalUserUpdate'
import { ProjectStatuses } from '../../../constants/Status'
import PortfolioProject from './PortfolioProject.js'
import RiskSolution from './RiskSolution'
import DocumentAssociation from './DocumentAssociation'
import Challenge from './Challenge'
import MilestoneBudget from './MilestoneBudget'
import AddResource from '../../../pages/ChangeRequest/activities/addResource'
import RemoveResource from '../../../pages/ChangeRequest/activities/removeResource'
import ProjectActivity from '../../../pages/ChangeRequest/activities/updateProject'
import AddMilestoneBudget from '../../../pages/ChangeRequest/activities/addMilestoneBudget'
import RemoveMilestoneBudget from '../../../pages/ChangeRequest/activities/removeMilestoneBudget'
import ChangeRequest from '../../../pages/ChangeRequest/activities/changeRequest'
import AddDeliverable from '../../../pages/ChangeRequest/activities/addDeliverable'
import EditDeliverable from '../../../pages/ChangeRequest/activities/editDeliverable'
import AddMilestone from '../../../pages/ChangeRequest/activities/addMilestone'
import EditMilestone from '../../../pages/ChangeRequest/activities/editMilestone'
import ApprovalUserChangeRequest from '../../../pages/ChangeRequest/activities/approval'
import ApprovalUserUpdateChangeRequest from '../../../pages/ChangeRequest/activities/approvalUpdate'
import Stakeholder from './Stakeholder.js'
import Comment from './Comment.js'
import Agenda from './Agenda.js'
import AgendaItem from './AgendaItem.js'
import Priority from './Priority.js'
import Status from './Status.js'
import Contact from './Contact.js'
import SuccessStory from './SuccessStory.js'
import ProjectDeliverable from './ProjectDeliverable.js'
function Actionlog({projectId}) {
  const [activities, setActivities] = useState([])
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if(projectId) {
      fetchData()
    }
  },[])
  async function fetchData() {
    try {
      setIsLoading(true);
      const query = {
        projectId: projectId,
        page: page + 1,
        perPage: DefaultPerPageValue,
      }
      const res = (await getAllAcivity(query)).data.data
      setActivities((prevState) => {
        return [...prevState, ...res.data];
      });
      setPage((prevState) => prevState + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
    
  }
  return (
    
      <>
      <InfiniteScroll
                dataLength={activities.length}
                next={fetchData}
                hasMore={hasMore}
                height={activities?.length ? "750px" : "auto"}
                loader={isLoading && <Loader />}
              >
                <ul className="list-inline allComments historyTab height-scroll">
                  { activities && Array.isArray(activities) && activities?.map((item, index) => (
                     <li className="d-flex py-3 mx-2" key={index}>
                     <div className="d-flex align-items-center">
                       <UserProfile user={item?.creator} avatarClassName='me-2 ml-2' profileClassName='me-2 ml-2' />
                       {[Action.CREATE, Action.UPDATE].includes(item.event) &&
                         item.module === ActivityModule.PROJECT && (
                           <Project item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === ActivityModule.DELIVERABLE && (
                           <Deliverable item= {item}  />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === ActivityModule.MILESTONE && (
                           <Milestone item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === ActivityModule.MILESTONE_BUDGET && (
                           <MilestoneBudget item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.TICKET && (
                           <Task item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE].includes(item.event) &&
                         item.module === Modules.STAKEHOLDER && (
                           <Stakeholder item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.RISK && (
                           <Risk item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === 'riskSolution' && (
                           <RiskSolution item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE].includes(item.event) &&
                         item.module === ActivityModule.PROJECT_USER && (
                           <ProjectUser item={item} />
                       )}
                       {[Action.CREATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.DOCUMENT && (
                           <Document item={item} />
                       )}
                       {[Action.CREATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.DOCUMENT_ASSOCIATION && (
                           <DocumentAssociation item={item} />
                       )}
                       {item.event === Action.CREATE &&
                          item.module === ActivityModule.APPROVAL_USER &&
                          item?.payload?.module !== ActivityModule.CHANGE_REQUEST && (
                            <ApprovalUserProject item={item} />
                          )}
                          {item.event === Action.UPDATE &&
                            item.module === ActivityModule.APPROVAL_USER && 
                            item?.payload?.module !== ActivityModule.CHANGE_REQUEST && (
                              <ApprovalUserUpdateProject item={item} />
                          )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                         item.module === 'portfolioProject' && (
                           <PortfolioProject item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === "projectChallenge" && (
                           <Challenge item={item} />
                       )}
                        {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.AGENDA && (
                           <Agenda item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.ITEM && (
                           <AgendaItem item={item} />
                       )}
                        {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === "priority" && (
                           <Priority item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === "status" && (
                           <Status item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === "contact" && (
                           <Contact item={item} />
                       )}
                       {[Action.CREATE, Action.UPDATE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST && (
                              <ChangeRequest item={item} />
                            )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.DELIVERABLE && item.payload?.event === Action.CREATE && (
                              <AddDeliverable item={item} />
                            )}
                            {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                         item.module === Modules.COMMENT && (
                           <Comment item={item} />
                       )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.DELIVERABLE && item.payload?.event === Action.UPDATE && (
                              <EditDeliverable item={item} />
                            )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.MILESTONE && item.payload?.event === Action.CREATE && (
                              <AddMilestone item={item} />
                            )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.MILESTONE && item.payload?.event === Action.UPDATE && (
                              <EditMilestone item={item} />
                            )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.PROJECT_USER && item.payload?.event === Action.CREATE && (
                              <AddResource item={item} />
                            )}
                          {[Action.CREATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.PROJECT_USER && item.payload?.event === Action.DELETE && (
                              <RemoveResource item={item} />
                            )}
                          {item.event === Action.CREATE &&
                            item.module === ActivityModule.APPROVAL_USER && item.payload?.module === ActivityModule.CHANGE_REQUEST && (
                              <ApprovalUserChangeRequest item={item} />
                            )}
                          {item.event === Action.UPDATE &&
                            item.module === ActivityModule.APPROVAL_USER && item.payload?.module === ActivityModule.CHANGE_REQUEST && (
                              <ApprovalUserUpdateChangeRequest item={item} />
                            )}
                          {item.event === Action.CREATE &&
                            item.module === ActivityModule.DELIVERABLE && item.payload.ChangeRequest && (
                              <AddDeliverable item={item} />
                            )}
                          {item.event === Action.UPDATE &&
                            item.module === ActivityModule.DELIVERABLE && item.payload.ChangeRequest && (
                              <EditDeliverable item={item} />
                            )}
                          {item.event === Action.CREATE &&
                            item.module === ActivityModule.MILESTONE && item.payload.ChangeRequest && (
                              <AddMilestone item={item} />
                            )}
                          {item.event === Action.UPDATE &&
                            item.module === ActivityModule.MILESTONE && item.payload.ChangeRequest && (
                              <EditMilestone item={item} />
                            )}
                          {item.event === Action.CREATE &&
                            item.module === ActivityModule.PROJECT_USER && item.payload.ChangeRequest && (
                              <AddResource item={item} />
                            )}
                          {item.event === Action.DELETE &&
                            item.module === ActivityModule.PROJECT_USER && item.payload.ChangeRequest && (
                              <RemoveResource item={item} />
                            )}
                          {item.module === ActivityModule.CHANGE_REQUEST_ITEM && item.payload?.module === ActivityModule.PROJECT && item.payload?.event === Action.UPDATE && (
                            <ProjectActivity item={item} />
                          )}
                          {item.module === ActivityModule.PROJECT && item?.event === Action.UPDATE && item?.payload?.ChangeRequest && (
                            <ProjectActivity item={item} />
                          )}
                          {item.event === Action.CREATE &&
                            item.module === ActivityModule.MILESTONE_BUDGET && item?.payload?.ChangeRequest && (
                              <AddMilestoneBudget item={item} />
                            )}
                          {item.event === Action.DELETE &&
                            item.module === ActivityModule.MILESTONE_BUDGET && item?.payload?.ChangeRequest && (
                              <RemoveMilestoneBudget item={item} />
                            )}
                          {[Action.CREATE, Action.UPDATE, Action.DELETE].includes(item.event) &&
                            item.module === ActivityModule.SUCCESS_STORY && (
                              <SuccessStory item= {item}  />
                          )}
                          {[Action.CREATE, Action.UPDATE].includes(item.event) &&
                         item.module === ActivityModule.PROJECT_DELIVERABLE && (
                           <ProjectDeliverable item= {item}  />
                       )}
                     </div>
                   </li>
                  ))}
                </ul>
              </InfiniteScroll>
    </>
  )
}
export default Actionlog